/**
 * .price-content-items-wrap の中に .p-postList（SWELL投稿リスト）が無ければ
 * 投稿0件とみなし、ラップごと非表示にする。
 * 直前に h2.wp-block-heading があれば（/productの子ページ）それも一緒に消す。
 */
export function hideEmptyPriceContentItems() {
	const wraps = document.querySelectorAll(".price-content-items-wrap, .p-productItem-list .price-content-items");

	wraps.forEach((wrap) => {
		if (wrap.querySelector(".p-postList")) return;

		const prev = wrap.previousElementSibling;
		if (prev && prev.matches("h2.wp-block-heading")) {
			prev.remove();
		}

		wrap.remove();
	});
}
